import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PlayerActivity() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [activity, setActivity] = useState(0);
  const onActivityChange = useCallback(
    (event) => setActivity(event.target.value),
    []
  );

  const [access, setAccess] = useState(0);
  const onAccessChange = useCallback(
    (event) => setAccess(event.target.value),
    []
  );

  const [wagerSource, setWagerSource] = useState(0);
  const onWagerSourceChange = useCallback(
    (event) => setWagerSource(event.target.value),
    []
  );

  const [wagerStatus, setWagerStatus] = useState(0);
  const onWagerStatusChange = useCallback(
    (event) => setWagerStatus(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetPlayerProfile`,
  });

  const [limitProfile, setLimitProfile] = useState("");
  const onLimitProfileChanged = useCallback((lp) => setLimitProfile(lp), []);
  const { values: limitProfiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/Player/GetPlayerProfileLimits`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile Limits"
          name="name"
          data={limitProfiles}
          placeholder="DataFormatter"
          setSelectValue={onLimitProfileChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Activity">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={activity}
                onChange={onActivityChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="With Bets"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Only Access"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Any Activity"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="No Activity"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Access">
            <FormControl component="fieldset">
              <RadioGroup label value={access} onChange={onAccessChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Online"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Local"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Wager Source">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={wagerSource}
                onChange={onWagerSourceChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Online"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Local"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Wager Status">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={wagerStatus}
                onChange={onWagerStatusChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Pending"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Settled"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Player Activity Report"
        getUrl={() => "/Reports/Report_PlayerActivity_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Office: office,
          LineType: lineType,
          Profile: profile,
          ProfileLimits: limitProfile,
          Distributor: distributor,
          Activity: 0,
          Access: 0,
          WagerSource: 0,
          WagerStatus: 0,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const accessTotal = item.accessLocal + item.accessOnline;
            const wagerTotal =
              item.openWagerLocal +
              item.openWagerOnline +
              item.gradedWagerLocal +
              item.gradedWagerOnline;

            return { ...item, accessTotal, wagerTotal };
          })
        }
        getTotals={(data) => ({
          player: "Total",
          accessLocal: data.reduce((acc, item) => acc + item.accessLocal, 0),
          accessOnline: data.reduce((acc, item) => acc + item.accessOnline, 0),
          accessTotal: data.reduce((acc, item) => acc + item.accessTotal, 0),
          gradedWagerLocal: data.reduce(
            (acc, item) => acc + item.gradedWagerLocal,
            0
          ),
          gradedWagerOnline: data.reduce(
            (acc, item) => acc + item.gradedWagerOnline,
            0
          ),
          openWagerLocal: data.reduce(
            (acc, item) => acc + item.openWagerLocal,
            0
          ),
          openWagerOnline: data.reduce(
            (acc, item) => acc + item.openWagerOnline,
            0
          ),
          wagerTotal: data.reduce((acc, item) => acc + item.wagerTotal, 0),
        })}
      >
        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="2"
          colSpan="1"
        ></TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="2"
          colSpan="3"
          className="table-header-groupped-left table-header-groupped-right"
          dataAlign="center"
        >
          Access
        </TableHeaderColumn>

        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="1"
          colSpan="5"
          className="table-header-groupped-left table-header-groupped-right table-header-groupped-bottom"
          dataAlign="center"
        >
          Wager
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="2"
          className="table-header-groupped-left table-header-groupped-right"
          dataAlign="center"
        >
          Pending
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="2"
          className="table-header-groupped-left table-header-groupped-right"
          dataAlign="center"
        >
          Settled
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="1"
          className=""
          dataAlign="center"
        ></TableHeaderColumn>

        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort row="2" dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort row="2" dataField="player">
          Player
        </TableHeaderColumn>
        {/* ACCESS */}
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="accessLocal"
          className="table-header-groupped-left"
        >
          Phone
        </TableHeaderColumn>
        <TableHeaderColumn dataSort row="2" dataField="accessOnline">
          Online
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="accessTotal"
          className="table-header-groupped-right"
        >
          Total
        </TableHeaderColumn>
        {/* PENDING */}
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="openWagerLocal"
          className="table-header-groupped-left"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="openWagerOnline"
          className="table-header-groupped-right"
        >
          Online
        </TableHeaderColumn>
        {/* SETTLED */}
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="gradedWagerLocal"
          className="table-header-groupped-left"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="2"
          dataField="gradedWagerOnline"
          className="table-header-groupped-right"
        >
          Online
        </TableHeaderColumn>
        <TableHeaderColumn dataSort row="2" dataField="wagerTotal">
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default PlayerActivity;
